(function () {
    'use strict';
    angular
        .module('app')
        .directive('gateKeeperDirective', gateKeeperDirective);
    gateKeeperDirective.$inject = ['$window', '$rootScope', '$scope', '$timeout', 'ngClipboard', '$mdDialog'];
    function gateKeeperDirective($window, $rootScope, scope, $timeout, ngClipboard, $mdDialog) {
        var directive = {
            link: link,
            restrict: 'EA',
            //scope: {
            //    msgBoxShown: '=?'
            //},
            //controller: 'browseFolderBox',
            templateUrl: 'app/gateKeeper/gateKeeper.html'
        };
        return directive;
        function link(scope, element, attrs) {
        }
    }
})();